import { cn } from '@/lib/utils';

/** The Tile Grid symbol — three modules forming a whole (DS logo system). */
export function TileGrid({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 84 84" fill="none" className={cn('block shrink-0', className)} aria-hidden>
      <polygon points="42,18 54,25 54,39 42,46 30,39 30,25" fill="rgba(2,169,247,0.18)" stroke="#02A9F7" strokeWidth="3.2" strokeLinejoin="round" />
      <polygon points="30,39 42,46 42,60 30,67 18,60 18,46" fill="rgba(2,169,247,0.10)" stroke="#02A9F7" strokeWidth="3.2" strokeLinejoin="round" />
      <polygon points="54,39 66,46 66,60 54,67 42,60 42,46" fill="#02A9F7" stroke="#02A9F7" strokeWidth="3.2" strokeLinejoin="round" />
    </svg>
  );
}

/** Wordmark — plain "Greffon" (the cyan graft notch was removed per product call). */
export function Wordmark({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cn('whitespace-nowrap font-sans font-bold tracking-tight text-fg', className)}
      style={{ fontSize: size }}
    >
      Greffon
    </span>
  );
}

export function Logo({ symbol = 24, word = 18 }: { symbol?: number; word?: number }) {
  return (
    <div className="flex items-center gap-2.5">
      <TileGrid size={symbol} />
      <Wordmark size={word} />
    </div>
  );
}
